import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	PetitionActionsContactDmConfigQuery,
	PetitionActionsContactDmConfigQueryVariables,
} from './getPetitionActionsContactDmConfig.graphql';
import { PetitionActionsContactDmConfig } from './getPetitionActionsContactDmConfig.graphql';

// FIXME this piece of logic should probably be moved to the middle-end, in the dm.email resolver
export async function getPetitionActionsContactDmConfig(
	utilityContext: UtilityContext,
): Promise<{ emailEnabled: boolean }> {
	const {
		data: {
			featureConfigs: { petitionPageContactDm },
		},
	} = await utilityContext.gql.fetch<PetitionActionsContactDmConfigQuery, PetitionActionsContactDmConfigQueryVariables>(
		{
			query: PetitionActionsContactDmConfig,
			rejectOnError: true,
		},
	);

	return { emailEnabled: !!petitionPageContactDm?.emailEnabled };
}
